/** Browser preferences belong to a deployment, never to the whole domain. */
export function createEnvironmentPreferences({
  baseUrl = process.env.BASE_URL || "/",
  apiUrl = process.env.VUE_APP_API_URL || process.env.VUE_APP_TITLE || "",
  storage,
} = {}) {
  const path = String(baseUrl).trim().replace(/^\/+|\/+$/g, "");
  const basePath = path ? `/${path}/` : "/";
  const api = String(apiUrl).trim().replace(/\/+$/, "");
  const prefix = `onboarding:preferences:v1:${encodeURIComponent(basePath)}:${encodeURIComponent(api)}:`;

  return {
    getItem(key) {
      try {
        return (storage || localStorage).getItem(`${prefix}${key}`);
      } catch {
        return null;
      }
    },
    setItem(key, value) {
      try {
        (storage || localStorage).setItem(`${prefix}${key}`, value);
      } catch {
        // Storage restrictions must not prevent the application from rendering.
      }
    },
  };
}

// Deliberately do not fall back to legacy, unscoped keys: their owner is unknown.
export const environmentPreferences = createEnvironmentPreferences();
